/* global BigInt */
export const COST_MODULES = ["read", "register", "approve_operational", "approve_finance", "pay", "admin"].map((name) => `cost_control_${name}`);
export const STATUSES = { draft: "Borrador", returned: "Devuelto", submitted: "Pendiente de aprobación operativa", operational_approved: "Pendiente de Finanzas", posted: "Contabilizado", reversed: "Reversado", approved: "Aprobado", superseded: "Reemplazado" };
export const ACTIONS = { submit: "Enviar a aprobación", "approve-operational": "Aprobar operación", "approve-finance": "Aprobar Finanzas", return: "Devolver", reverse: "Reversar" };
export function can(access, capability) { return Boolean(access?.isAdmin || access?.capabilities?.includes(capability) || access?.capabilities?.includes(`cost_control_${capability}`)); }
export function money(value, currency = "CLP") {
  if (value === null || value === undefined) return "—";
  const amount = String(value ?? "0");
  if (!/^-?\d+(\.\d+)?$/.test(amount)) return "—";
  const [whole, fraction = ""] = amount.split(".");
  return `${currency} ${whole.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}${fraction && fraction !== "00" ? `,${fraction.padEnd(2, "0")}` : ""}`;
}
export function date(value) {
  const iso = String(value || "").slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(iso) ? iso.split("-").reverse().join("/") : "—";
}
export function today() {
  return new Intl.DateTimeFormat("en-CA", { timeZone: "America/Santiago", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());
}
export function cents(value) {
  const match = /^(-?)(\d+)(?:\.(\d{1,2}))?$/.exec(String(value || "0"));
  if (!match) throw new Error("Ingresa montos con punto decimal y hasta dos decimales.");
  const amount = BigInt(match[2]) * 100n + BigInt((match[3] || "").padEnd(2, "0"));
  return match[1] ? -amount : amount;
}
export function decimal(value) {
  const negative = value < 0n;
  const absolute = negative ? -value : value;
  return `${negative ? "-" : ""}${absolute / 100n}.${String(absolute % 100n).padStart(2, "0")}`;
}
export function rateUnits(value) {
  const match = /^(\d+)(?:\.(\d{1,8}))?$/.exec(String(value));
  if (!match) throw new Error("Tipo de cambio inválido.");
  const rate = BigInt(match[1]) * 100000000n + BigInt((match[2] || "").padEnd(8, "0"));
  if (rate <= 0n) throw new Error("El tipo de cambio debe ser positivo.");
  return rate;
}
export function convertCents(value, exchangeRate = "1") { return (cents(value) * rateUnits(exchangeRate) + 50000000n) / 100000000n; }
export function lineCost(line, exchangeRate = "1") { return decimal(convertCents(line.net, exchangeRate) + convertCents(line.nonrecoverableTax, exchangeRate)); }
export function query(filters = {}) {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => { if (value !== "" && value !== undefined && value !== null) params.set(key, value); });
  const encoded = params.toString();
  return encoded ? `?${encoded}` : "";
}
export function availableActions(document, access) {
  const actions = document?.available_actions || [];
  const editable = actions.includes("edit") || actions.includes("update") || (["draft", "returned"].includes(document?.status) && String(document.requester_code) === String(access?.code) && can(access, "register"));
  return { actions, editable };
}
